import { viteAppBaseUrl } from '@/constants/env';
import { usePatientPhoneNumber } from '@/hooks/usePatientPhoneNumber';
import {
  AmazonConnectCcpLauncher,
  AmazonConnectCcpProvider,
  ConfigProvider as TelecomConfigProvider
} from '@montugroup/clinic-telecom';

import {
  FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2,
  FF_C4C_RECORD_VOICE_CALL,
  FF_C4C_VOICE_CALL
} from '../../constants/featureFlags';
import settings from '../../data/constants';
import { useFeatureFlags } from '../../hooks/flags/useFeatureFlags';

// TODO: [B2C-8488] Remove deprecated immediate nurse consultation implementation
/** @deprecated - Amazon Connect is applied globally using AmazonConnectProvider and AmazonConnect components */
export const withAmazonConnectCcp = <P extends object>(Component: React.ComponentType<P>) => {
  const WithAmazonConnectCcp = (props: P) => {
    const { flags } = useFeatureFlags();
    const { shouldDisplayPatientPhoneNumber } = usePatientPhoneNumber();
    const isVoiceCallEnabled = flags[FF_C4C_VOICE_CALL];
    const canRecordCalls = flags[FF_C4C_RECORD_VOICE_CALL];
    const ffImmediateNurseConsultationV2 = flags[FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2];
    const baseUrl = viteAppBaseUrl();

    if (ffImmediateNurseConsultationV2 || !isVoiceCallEnabled) {
      return <Component {...props} />;
    }

    return (
      <TelecomConfigProvider baseUrl={baseUrl}>
        <AmazonConnectCcpProvider
          ccpUrl={settings.connect.ccpInstanceUrl}
          loginUrl={settings.connect.samlLoginUrl}
          supportUrl={settings.serviceDeskUrl}
          canRecordCalls={canRecordCalls}
          shouldDisplayPatientPhoneNumber={shouldDisplayPatientPhoneNumber}
        >
          <Component {...props} />
          <AmazonConnectCcpLauncher />
        </AmazonConnectCcpProvider>
      </TelecomConfigProvider>
    );
  };

  return WithAmazonConnectCcp;
};
